import React from "react";
import { ActionIcon, Box, Button, Group, Stack, Text } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import DetailInternational from "@/modules/manage-transaction/transaction-detail/component/detail-international/DetailInternational";
import RecallModal from "@/modules/manage-transaction/transaction-detail/component/recall-modal/RecallModal";
import { useTranslation } from "react-i18next";

/**
 * TRANG PREVIEW TẠM (demo/thông màn) — xem màn "Xem chi tiết giao dịch CTQT"
 * mà không cần API. Bản thật render trong TransactionDetail theo businessType +
 * dữ liệu API. Xoá route này khi đã ghép API.
 */
const TransInterDetailPreview: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [recallOpened, { open: openRecall, close: closeRecall }] =
    useDisclosure(false);

  return (
    <Stack spacing="md" pt="md" pb={96}>
      <Group>
        <ActionIcon variant="transparent" onClick={() => navigate(-1)}>
          <IconArrowLeft size={24} stroke={1.5} color="black" />
        </ActionIcon>
        <Text fw={700} fz="lg">
          {t("VIEW_TRANSACTION_DETAILS")}
        </Text>
      </Group>

      <DetailInternational />

      {/* Thanh dưới: nút Thu hồi giao dịch */}
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          left: "calc(var(--mantine-navbar-width, 0px) + 20px)",
          right: 0,
          padding: "10px 24px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          boxShadow: "0px 5px 15px 0px #00000026",
          borderRadius: "12px",
          height: "76px",
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <Button
          onClick={openRecall}
          sx={() => ({
            backgroundColor: "#2A81D0",
            color: "white",
            borderRadius: 8,
            padding: "10px 24px",
            "&:hover": { backgroundColor: "#2470bb" },
          })}
        >
          {t("WITHDRAW_TRANSACTION")}
        </Button>
      </Box>

      <RecallModal
        opened={recallOpened}
        onClose={closeRecall}
        onConfirm={closeRecall}
        transactionTypeLabel={t("INTERNATIONAL_TRANSFER_LOWER")}
      />
    </Stack>
  );
};

export default TransInterDetailPreview;
